import { FileResultType } from '../../../../Helper/file';
import { excelDateToJSDate } from '../../../ShipmentHistory/BulkStatusUpload/helper';
import { PurchaseBulkPaymentType } from './types';

export function readXslAndGetBulkPaymentUploadObject(data: FileResultType[]) {
  const [{ fileData }] = data;
  if (!(fileData instanceof Array)) return;

  const {
    data: [headers, ...body],
  } = fileData[0] as { data: string[][] };

  // Indexes of required columns
  const invoiceNumberIndex = headers.findIndex(x => x && x.match(/invoice number/i));
  const amountPaidIndex = headers.findIndex(x => x && x.match(/amount paid/i));
  const tdsIndex = headers.findIndex(x => x && x.match(/tds/i));
  const modeOfPaymentIndex = headers.findIndex(x => x && x.match(/mode of payment/i));
  const commentIndex = headers.findIndex(x => x && x.match(/comment/i));
  const paymentDateIndex = headers.findIndex(x => x && x.match(/payment date/i));
  const refInvoiceNoIndex = headers.findIndex(x => x && x.match(/ref\.?\s*invoice\s*no/i));

  // Validation checks
  if (invoiceNumberIndex === -1) throw { msg: 'Invoice number column not found in xlsx' };
  else if (!body.length) throw { msg: 'At least one invoice is required' };
  else if (amountPaidIndex === -1) throw { msg: 'Amount paid column not found in xlsx' };
  else if (tdsIndex === -1) throw { msg: 'TDS column not found in xlsx' };
  else if (modeOfPaymentIndex === -1) throw { msg: 'Mode of payment column not found in xlsx' };
  else if (commentIndex === -1) throw { msg: 'Comment column not found in xlsx' };
  else if (paymentDateIndex === -1) throw { msg: 'Payment date column not found in xlsx' };
  else if (refInvoiceNoIndex === -1) throw { msg: 'Ref. Invoice No column not found in xlsx' };

  // Formatting payment data
  const formattedBody: string[][] = body
    .filter(data => data[invoiceNumberIndex])
    .map(data => {
      if (!data[amountPaidIndex]) throw { msg: `Amount paid not found for invoice ${data[invoiceNumberIndex]}` };
      if (!data[modeOfPaymentIndex]) throw { msg: `Mode of payment not found for invoice ${data[invoiceNumberIndex]}` };
      if (!data[commentIndex]) throw { msg: `Comment not found for invoice ${data[invoiceNumberIndex]}` };
      if (!data[paymentDateIndex]) throw { msg: `Payment date not found for invoice ${data[invoiceNumberIndex]}` };

      // Convert the Excel serial number to date string if necessary
      const paymentDate =
        typeof data[paymentDateIndex] === 'number'
          ? excelDateToJSDate(data[paymentDateIndex] as any)
          : data[paymentDateIndex];

      const paymentMode = data[modeOfPaymentIndex].toLowerCase().replace(/\s+/g, '');

      return {
        ...data,
        [paymentDateIndex]: paymentDate,
        [modeOfPaymentIndex]: paymentMode,
      };
    });

  const bulkData: PurchaseBulkPaymentType[] = formattedBody.map(arr => ({
    invoiceNumber: String(arr[invoiceNumberIndex]),
    amount: parseFloat(arr[amountPaidIndex]),
    tdsAmount: parseFloat(arr[tdsIndex]) || 0,
    paymentMode: arr[modeOfPaymentIndex].toLowerCase(),
    comment: arr[commentIndex],
    paymentDate: arr[paymentDateIndex],
    refInvoiceno: arr[refInvoiceNoIndex] ? String(arr[refInvoiceNoIndex]) : '',
  }));

  return bulkData;
}
